"use client";

import React from "react";
import { Megaphone, MessageCircle, CalendarCheck, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const steps = [{
  id: 1,
  title: "Analisi Iniziale",
  description: "Valutazione approfondita del profilo e dei requisiti normativi per determinare la strategia di mobilità internazionale più efficace.",
  icon: Megaphone
}, {
  id: 2,
  title: "Preparazione Documentale",
  description: "Gestione meticolosa di tutta la documentazione necessaria, garantendo la massima precisione per evitare ritardi burocratici.",
  icon: MessageCircle
}, {
  id: 3,
  title: "Esecuzione e Visto",
  description: "Presentazione delle istanze presso le autorità competenti e monitoraggio costante fino all'ottenimento del titolo richiesto.",
  icon: CalendarCheck
}];
export default function The3StepPatientJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223380" id="percorso-di-conformità" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(hsl(var(--secondary)/0.1)_1px,transparent_1px)] [background-size:32px_32px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4 tracking-tight">
            Percorso di Conformità
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Un processo strutturato ed elegante per guidare la vostra mobilità internazionale con assoluta certezza legale.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden md:block absolute top-[3.5rem] left-[16%] right-[16%] h-0.5 border-t-2 border-dashed border-secondary/40 animate-pulse z-0" />

          {}
          <div className="md:hidden absolute top-[10%] bottom-[10%] left-[3.25rem] w-0.5 border-l-2 border-dashed border-secondary/40 animate-pulse z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={step.id} data-index={i} className="relative z-10 flex flex-col items-start md:items-center text-left md:text-center group">
                  <div className="flex flex-row md:flex-col items-center md:items-center gap-6 md:gap-6 w-full">
                    {}
                    <div className="relative shrink-0">
                      <div className="absolute inset-0 bg-secondary/10 rounded-lg blur-2xl group-hover:bg-secondary/20 transition-colors duration-700" />
                      <div className="relative w-20 h-20 md:w-28 md:h-28 rounded-sm bg-background border border-secondary/30 flex items-center justify-center shadow-lg group-hover:shadow-secondary/20 transition-shadow duration-500">
                        <Icon className="w-8 h-8 md:w-12 md:h-12 text-secondary" strokeWidth={1} />
                        
                        {}
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary text-secondary-foreground flex items-center justify-center font-bold text-sm shadow-md border border-primary/10">
                          {step.id}
                        </div>
                      </div>
                    </div>

                    {}
                    <div className="flex-1 md:w-full">
                      <h3 className="text-xl md:text-2xl font-semibold font-default text-primary mb-3">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground font-default leading-relaxed text-sm md:text-base">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        <div className="mt-20 text-center">
          <Button asChild size="lg" className="px-10 bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary font-semibold transition-all duration-300 shadow-xl">
            <Link to="/ContactsPage">
              Inizia la Consulenza <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}